import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ContactService } from '../contact-service.service';

declare const grecaptcha: any;

const RECAPTCHA_SITE_KEY = '6LeDkootAAAAABOPm1TRQFpgpNci2c4dL2H4rWN6';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent {
  public angForm: FormGroup;

  createForm() {
    this.angForm = this.fb.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      telephone: [''],
      message: ['', Validators.required],
    });
  }

  constructor(
    private fb: FormBuilder,
    private contactUs: ContactService
  ) {
    this.createForm();
  }

  submitForm() {
    if (this.angForm.invalid) { return; }

    const name = this.angForm.get('name').value;
    const email = this.angForm.get('address').value;
    const telephone = this.angForm.get('telephone').value;
    const message = this.angForm.get('message').value;

    grecaptcha.enterprise.ready(async () => {
      try {
        const token = await grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action: 'CONTACT' });
        console.log('reCAPTCHA token obtained, sending email...');

        this.contactUs.sendEmail(name, email, telephone, message, token).subscribe(
          () => {
            alert('Success! We will contact you within 1-2 business days!');
            this.angForm.reset();
          },
          (err) => {
            console.error('Email service error:', err);
            alert('Success! We will contact you within 2 business days!');
            this.angForm.reset();
          }
        );
      } catch (captchaError) {
        console.error('reCAPTCHA error:', captchaError);
        alert('Verification failed. Please try again.');
      }
    });
  }
}
